






















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass, TbGoodsSpecs } from '@/http';
import { addSpecsPanel,logoutPanel } from "@/components"
import { Toast } from 'vant';
@Component({ 
    components: {
        addSpecsPanel,logoutPanel
    },
})
export default class specs extends Vue {
   
    public $refs: {
    };

    specNameList=[];

    activeInfo:any={}

    /**添加规格 */
    addSpecsShow = false;
    isAddName = true;
    specsInfo:any = {};

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    deleteId="";
    isDeleting = false;

    Loop=null;

    deleteSItem:any={};

    activeInfoIndex=null;
    clickCount = 0;
    lasttaptime = 0;

    isEdit = null;

    created() {
        
    }

    async mounted(){
      this.init();
    }

    async init(){
        let res = await TbGoodsSpecs.GetTbGoodsSpecsList();
        this.specNameList = res;
        if(res.length>0){
            this.activeInfo=res[0]
            this.activeInfoIndex = 0;
        }
    }

    async onRefresh(){
        let res = await TbGoodsSpecs.GetTbGoodsSpecsList();
        this.specNameList = res;
        this.activeInfoIndex=this.activeInfoIndex?this.activeInfoIndex:0;
        if(res.length>0){
            this.activeInfo = this.specNameList[this.activeInfoIndex];
        }else{
            this.activeInfo = {};
        }
    }

    chooseSpec(item,index){
        this.activeInfo = item;
        this.activeInfoIndex = index;
    }

    cancelFun(){
        this.addSpecsShow = false;
    }
    async confirmAddSpecs(){
        await this.onRefresh();
        // if(!this.activeInfoIndex){
            this.activeInfoIndex = 0;
        // }
        this.activeInfo = this.specNameList[this.activeInfoIndex]
    }

    addSpecs(){
        this.isAddName = true;
        this.isEdit = null;
        this.addSpecsShow = true;
        this.$refs['addSpecsref'].init();
    }
    addSpecsVal(item){
        if(this.specNameList.length==0){
            this.tipTitle = "操作提醒";
            this.tipText = `请先新增规格！`;
            this.btnNums=1;
            this.confirmText = "确定";
            this.tipType = 3;
            this.deleteId = item.id;
            this.tipShow = true;
            return;
        }
        this.specsInfo = item;
        this.isAddName = false;
        this.isEdit = null;
        this.addSpecsShow = true;
        this.$refs['addSpecsref'].init();
    }

    /**删一级 */
    async deleteFun(){
        if(this.isDeleting) return;
        this.isDeleting = true;
        try {
            let res = await TbGoodsSpecs.DeleteTbGoodsSpecs(this.deleteId);
            this.isDeleting = false;
            Toast("删除成功");
            this.activeInfoIndex = 0;
            await this.onRefresh();
        } catch (error) {
            this.isDeleting = false;
        }
    }
    /**删二级 */
    async deleteSFun(){
        if(this.isDeleting) return;
        this.isDeleting = true;
        try {
            let obj = {
                id:this.activeInfo.id,
                name:this.activeInfo.name,
                delSpecsItemsJson:[{
                    id:this.deleteSItem.id,
                    name:this.deleteSItem.name,
                }],
                specsItemsJson:this.formateArr()
            }
            let res = await TbGoodsSpecs.PutTbGoodsSpecs(obj);
            this.isDeleting = false;
            Toast("删除成功");
            await this.onRefresh();
        } catch (error) {
            this.isDeleting = false;
        }
    }
    formateArr(){
        let arr = [];
        arr = this.activeInfo.specsItemsJson.filter(v=>v.id!=this.deleteSItem.id)
        return arr;
    }
    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            case 1:
                this.deleteSFun()
                break;
            case 2:
            this.deleteFun()
                break;
        
            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    async delItem(){
        await this.fTouchstart(this.specsInfo)
        setTimeout( async ()=>{
            await this.touchend()
        },200)
    }

    fTouchstart(item){
        console.log('touchstart');
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            this.tipTitle = "删除规格提醒";
            this.tipText = `删除后，商品则无法使用该“${item.name}”，确定删除吗？`;
            this.btnNums=2;
            this.confirmText = "确定删除";
            this.cancelText = "取消"
            this.tipType = 2;
            this.deleteId = item.id;
            this.tipShow = true;
        }.bind(this), 200);//手指或者鼠标按下等待的时间
    }
    // 左侧列表 单 双击时间
    handleClick(item,index,type){
        let curtime = Date.now();
        // 上一次触摸时间
        let lasttime = this.lasttaptime;
        console.log(curtime,lasttime);
        if(this.lasttaptime==0){    //单击
            this.lasttaptime = curtime;
            setTimeout( ()=> {
                this.clickCalculation(item,index,type);
            }, 300)
            
        }else{
            if(curtime - lasttime <300) {
                console.log('shuan双击');
                this.clickCount = 1;
            }
        }
    }
    async clickCalculation(item,index,type){
        if (this.clickCount === 0) {
            console.log("单击")
            if(type==1){
                this.chooseSpec(item,index);
            }else{
                this.editGGZ(item,index);
            }
            this.clickCount = 0;
            this.lasttaptime = 0;
            
        } else {
            console.log("双击")
            if(type==1){
                this.editGG(item,index);
            }else{
                // this.editGGZ(item,index);
                await this.touchstart(item)
                setTimeout( async ()=>{
                    await this.touchend()
                },200)
            }
            this.clickCount = 0;
            this.lasttaptime = 0;
        }

    }
    // 左侧编辑
    editGG(item,index){
        console.log('edititem',item,index);
        this.isEdit = 1;
        this.isAddName = true;
        this.specsInfo = item;
        this.addSpecsShow = true;
        this.$refs['addSpecsref'].init1(item);
    }
    // 右侧编辑
    editGGZ(item,index){
        this.isEdit = 2;
        this.isAddName = false;
        this.specsInfo = this.activeInfo;
        this.addSpecsShow = true;
        this.$refs['addSpecsref'].init1(item);
        console.log('editGGZ',item,index);
    }
    touchstart(item){
        // if(!this.isManage)return;
        console.log('touchstart');
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            this.tipTitle = "删除规格提醒";
            this.tipText = `删除后，商品则无法使用该规格，确定删除吗？`;
            this.btnNums=2;
            this.confirmText = "确定";
            this.cancelText = "取消"
            this.tipType = 1;
            this.deleteSItem = item;
            this.tipShow = true;
        }.bind(this), 200);//手指或者鼠标按下等待的时间
    }
    touchend(){
        // if(!this.isManage)return;
        console.log('touchend');
        clearInterval(this.Loop);
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/product/components/specs.vue